import { axios } from "@app/app/services/axios";
import { queryClient } from "@app/app/services/queryClient";

import { QueryKeys } from "./constants/QueryKeys";
import { IProperty } from "./types";

export const getProperty = async (propertyId: string): Promise<IProperty> => {
    const response = await axios.get(`/properties/${propertyId}/`);

    return response.data;
};

export const prefetchProperty = (propertyId: string) =>
    queryClient.prefetchQuery([QueryKeys.PropertyItem, propertyId], () => getProperty(propertyId), {
        staleTime: 1000 * 60 * 1, // 1 minute
    });
